module.exports = __webpack_public_path__ + "img/5.950513df.png";